import { handle_popup, getLoadingPopup } from './handle_popup.js'

export function initRecommendPopup() {
    const btns = document.querySelectorAll(`[data-name="add-to-cart"]`)
    btns.forEach((btn) => {
        btn.addEventListener('click', async function (e) {
            e.stopPropagation()
            if (getLoadingPopup()) return null
            handle_popup(this.dataset.prodId)
        })
    })
}
